import { roundDecimalPlaces, distanceConnect } from './utils.js'


class ShapeConnectGroups {

    constructor(
        shape,
    ) {
        this.shape = shape
    }

    // When doing groups, completely change the method and automatically 
    // calculate things instead of trying to do mental math to make it 
    // all line up
    getShapeOuterParamsGroup(args) {
        let outerParams = []
        let gaps = args.getGroupGaps()
        let offsets = args.getGroupOffsets()
        offsets = offsets.length > 0 ? offsets : Array(gaps.length).fill(0)
        let arcs = args.getGroupArcs()
        let originalStart = [0 + offsets[0], gaps[0] + offsets[0]]
        let start, end, prevStart, arc, step
        for (let g of args.getGroups()) {
            // Stuff to do before creating the group
            // To configure or reconfigure
            let offset = offsets.shift()
            prevStart = gaps.length > 0 ? [0 + offset, gaps.shift() + offset] : originalStart
            // If you ask for an even number, changes the calc to give 
            // that many separate connectors. 
            // If just doing 1 / g, they overlap and you get 1/2
            step = g % 2 === 0 ? 1 / g / 2 : 1 / g
            arc = arcs.length > 0 ? arcs.shift() : arc
            outerParams.push([])
            for (let i = 0; i < g; i++) {
                for (let i = 0; i < 2; i++) {
                    start = roundDecimalPlaces(prevStart[i] + step, 4)
                    end = roundDecimalPlaces(start + arc[i], 4)
                    outerParams.at(-1).push(start, end)
                    prevStart[i] = start
                }
            }
        }
        return outerParams
    }

    getConnectingPointsGroup(args, outerParams) {
        let curvePoints = []
        // Extents are analogous to the distances but serve to tell 
        // the shapes involved how to scale the relative arcs
        let extents = []
        let sizes = args.getGroupSizes()
        let size = sizes.length > 0 ? sizes.at(0) : [1, 1]
        for (let groupParams of outerParams) {
            // Do anything needed for group configuration here
            size = sizes.length > 0 ? sizes.shift() : size
            for (let i = 0; i < groupParams.length; i+=4) {
                extents = extents.concat([size[0] * args.arcAdjust[0], size[1] * args.arcAdjust[1]])
                // These point will be from higher to lower params,
                // forming the start arc of the shape
                curvePoints.push(distanceConnect(this.shape, groupParams[i + 3], groupParams[i], size[0]))
                curvePoints.push(distanceConnect(this.shape, groupParams[i + 2], groupParams[i + 1], size[0]))
                // and these will be from lower to higher params,
                // the end arc
                curvePoints.push(distanceConnect(this.shape, groupParams[i + 1], groupParams.at(i + 2), size[1]))
                curvePoints.push(distanceConnect(this.shape, groupParams[i], groupParams[i + 3], size[1]))
            }
        }
        return [extents, curvePoints]
    }


    buildConnecting(args, shape, points, params, extent) {
        let path = ``

        // Go to start
        path = `${path} M ${points[0].x} ${points[0].y} `

        // Draw arc for lower param edge of the shape
        path = args.connectPoints ? `${path} L ${points[1].x} ${points[1].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(0, 2), extent[0])} `

        // Go to start of outer arc
        path = `${path} L ${points[2].x} ${points[2].y} `

        // Draw outer arc or line
        path = args.connectPoints ? `${path} L ${points[3].x} ${points[3].y} ` : `${path} ${shape.getSubCurveRelative(...params.slice(2, 4), extent[1])} `

        // Line back to start
        path = `${path} L ${points[0].x} ${points[0].y} `
        return path
    }


    getConnectingShapesGroups(args, outerParams, curvePoints, extents) {
        let shapePaths = []
        for (let i = 0; i < curvePoints.length - 3; i+=4) {
            let points = curvePoints.slice(i, i + 4)
            let params = outerParams.slice(i, i + 4)
            let extent = extents.slice(i / 2, i / 2 + 2)
            shapePaths.push(this.buildConnecting(args, this.shape, points, params, extent))
        }
        return shapePaths
    }


    getConnectingGroups(args) {
        let outerParams = this.getShapeOuterParamsGroup(args)
        let [extents, curvePoints] = this.getConnectingPointsGroup(args, outerParams)
        let connectingShapes = this.getConnectingShapesGroups(args, outerParams.flat(), curvePoints, extents)
        let groupedShapes = []
        for (let group of args.groups) {
            groupedShapes.push([])
            for (let i = 0; i < group; i++) {
                groupedShapes.at(-1).push(connectingShapes.shift())
            }
        }
        return [groupedShapes, curvePoints]
    }

}

export { ShapeConnectGroups }
